import { plural } from '@cian/utils';
import { SpecialGeo } from '../../components/SpecialGeo';
import { useGeneralInfo } from '../../hooks';
import { useMemo } from 'react';
import { stopPropagation } from 'shared/utils/event';
import { UndergroundIconContainer } from './UndergroundIconContainer';

export function UndergroundContainer() {
  const { geo } = useGeneralInfo();

  const remoteness = useMemo(() => {
    if (!geo) {
      return;
    }

    const { underground } = geo;

    if (underground && underground.time && underground.time > 0) {
      const unit = plural(underground.time, ['минута', 'минуты', 'минут']);
      const transportType = underground.transportType === 'walk' ? 'пешком' : 'на транспорте';

      return `${underground.time} ${unit} ${transportType}`;
    }

    return undefined;
  }, [geo]);

  if (!geo?.underground) {
    return null;
  }

  return (
    <SpecialGeo
      label={geo.underground.name}
      icon={<UndergroundIconContainer />}
      remoteness={remoteness}
      onClick={stopPropagation}
    />
  );
}
